import { FC, ReactNode } from 'react';
import { ContentContainer, Image, Root, Content } from './styled';

type Props = {
  children?: ReactNode;
  imageUrl?: string;
  onClick?: () => void;
  isPressable?: boolean;
  displayType?: string;
};

const TableDataCell: FC<Props> = ({
  children,
  imageUrl,
  onClick,
  isPressable = false,
  displayType = 'flex',
}) => {
  return (
    <Root $isPressable={isPressable} $displayType={displayType} onClick={onClick}>
      <ContentContainer $isPressable={isPressable} $displayType={displayType}>
        {imageUrl && <Image src={imageUrl} alt="Cell image" />}
        <Content>{children}</Content>
      </ContentContainer>
    </Root>
  );
};

export default TableDataCell;
